import { render, staticRenderFns } from "./CourtCases.vue?vue&type=template&id=0f1c285c&scoped=true&"
import script from "./CourtCases.vue?vue&type=script&lang=js&"
export * from "./CourtCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c285c",
  null
  
)

export default component.exports